import React from 'react'
import { StyledCadastreSe } from './styles.style'
import VisibilitySensor from 'react-visibility-sensor'
import bus from '../../../../../assets/images/muvibus/bus.png'
import { routes } from '../../../../constants/routes.constants'
import Logomark from '../../../../components/layout/logomark.component'
import Container from '../../../../components/layout/container.component'
import LinkButton from '../../../../components/buttons/link-button.component'

class RegisterPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			busIsVisible: false
		}
	}

	showBus = isVisible => this.setState({ busIsVisible: isVisible })

	render() {
		return (
			<StyledCadastreSe>
				<Container>
					<div className="info">
						<Logomark />
						<h2>
						<span className="orange">Cadastre-se e viaje</span><br />
								<span className="blue">muito mais com o</span><br />
								<span className="blue" style={{ fontSize: '8rem' }}>
										Muviflex
								</span>
						</h2>
						<LinkButton to={routes.CADASTRO}>Eu quero :-)</LinkButton>
					</div>
				</Container>
				<VisibilitySensor
					onChange={this.showBus}
					partialVisibility={true}
					active={!this.state.busIsVisible}>
					<img
						src={bus}
						alt="Muvibus"
						className={this.state.busIsVisible ? 'bus show' : 'bus'}
					/>
				</VisibilitySensor>
			</StyledCadastreSe>
		)
	}
}

export default RegisterPage
